function parsePositiveId(value: unknown): number | null {
  if (typeof value === "number" && value > 0) {
    return value;
  }
  if (typeof value === "string" && value.trim() !== "") {
    const asNumber = Number(value);
    if (Number.isFinite(asNumber) && asNumber > 0) {
      return asNumber;
    }
  }
  return null;
}

export function extractRecordId(responseText: string): number | null {
  try {
    const parsed = JSON.parse(responseText);

    if (parsed && typeof parsed === "object" && parsed.error) {
      return null;
    }

    const candidates: unknown[] = [
      parsed?.data?.id,
      parsed?.id,
      parsed?.result?.id
    ];

    for (const candidate of candidates) {
      const id = parsePositiveId(candidate);
      if (id != null) {
        return id;
      }
    }
  } catch {
    return null;
  }

  return null;
}
